import type {
  CoachingPartnership,
  CoachingPartnershipStatus,
} from '@efdigital/ll-addon-data';
import { DataTypeCoaching } from '@efdigital/ll-addon-data/data-types';
import { cacheKeyFor, type Store } from '@warp-drive/core';
import {
  createRecord,
  query,
  updateRecord,
} from '@warp-drive/utilities/json-api';

import { jsonApiOptions, page, type PageOptions } from '../../json-api.ts';

const MAX_PARTNERSHIPS_PER_COACHEE = 100;

export function queryCoachingPartnershipsByCoachingPlan(
  coachingPlanId: string
) {
  return query<CoachingPartnership>(
    DataTypeCoaching.CoachingPartnership,
    {
      'filter[coachingPlan.id]': coachingPlanId,
      ...page({ offset: 0, limit: MAX_PARTNERSHIPS_PER_COACHEE }),
    },
    jsonApiOptions
  );
}

export function queryCoachingPartnershipsByCoachingPlanAndCoach(
  coachingPlanId: string,
  coachUserId: string
) {
  return query<CoachingPartnership>(
    DataTypeCoaching.CoachingPartnership,
    {
      'filter[coachingPlan.id]': coachingPlanId,
      'filter[coachUserId]': coachUserId,
      ...page({ offset: 0, limit: MAX_PARTNERSHIPS_PER_COACHEE }),
    },
    jsonApiOptions
  );
}

export function queryCoachingPartnershipsByCoach(
  coachUserId: string,
  status: CoachingPartnershipStatus[],
  pagingOptions?: PageOptions
) {
  return query<CoachingPartnership>(
    DataTypeCoaching.CoachingPartnership,
    {
      ...(status.length ? { 'filter[status][$in][]': status } : {}),
      'filter[coachUserId]': coachUserId,
      ...page(
        pagingOptions ?? { offset: 0, limit: MAX_PARTNERSHIPS_PER_COACHEE }
      ),
    },
    jsonApiOptions
  );
}

export function createCoachingPartnership(
  coachingPartnership: CoachingPartnership,
  store: Store
) {
  const init = createRecord(coachingPartnership, {
    ...jsonApiOptions,
  });

  init.body = JSON.stringify({
    data: store.cache.peek(cacheKeyFor(coachingPartnership)),
  });

  init.headers.set('Content-Type', 'application/vnd.api+json');
  return init;
}

export function updateCoachingPartnership(
  coachingPartnership: CoachingPartnership,
  store: Store
) {
  const init = updateRecord(coachingPartnership, {
    ...jsonApiOptions,
    patch: true,
  });

  init.body = JSON.stringify({
    data: store.cache.peek(cacheKeyFor(coachingPartnership)),
  });

  init.headers.set('Content-Type', 'application/vnd.api+json');
  return init;
}
